import axios from 'axios';
import variables from '../helpers/variables';
import Cookies from 'js-cookie';

const api = axios.create({
  baseURL: variables.API_URL
});

api.interceptors.request.use((config) => {
  const token = Cookies.get("auth_token");
  if (token && config.headers) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;